const PRODUCT_FIELD_LABELS = {
  productNo: '產品代號',
  name: '名稱',
  salesUnitName: '銷售單位',
  customerId: '客戶',
  customerProductNo: '客戶料號',
  remark: '備註',
  materials: '物料',
  extraItems: '附加項目',
};

function resolveProductFieldLabel(path) {
  const materialMatch = path.match(/^materials\.(\d+)\.(.+)$/);
  if (materialMatch) {
    const index = Number(materialMatch[1]) + 1;
    const field = materialMatch[2];
    const fieldLabels = {
      mtrId: '物料',
      qtyPerProduct: '每產品用量',
      remark: '備註',
    };
    return `物料 #${index} ${fieldLabels[field] || field}`;
  }

  const extraMatch = path.match(/^extraItems\.(\d+)\.(.+)$/);
  if (extraMatch) {
    const index = Number(extraMatch[1]) + 1;
    const field = extraMatch[2];
    const fieldLabels = {
      itemName: '項目名稱',
      qtyPerProduct: '數量',
      unitName: '單位',
      remark: '備註',
    };
    return `附加項目 #${index} ${fieldLabels[field] || field}`;
  }

  return undefined;
}

export {
  PRODUCT_FIELD_LABELS,
  resolveProductFieldLabel,
};
